import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
import { useFetchServerFeaturesQuery } from '../../../redux/api/appMarket-api-slice';
import { EntityId, EntityState } from '@reduxjs/toolkit';
import { ServerFeatures } from '../../../models/enums';
import { DeveloperAppReview } from '../../../models/app';
import { CommentBlock } from './comment-block';
import { ReviewsConfig } from './index';
import { TertiaryButton } from '@clover/web-lib-core/components';
import { ButtonVariant } from '@clover/web-lib-core/dist/components/CoreButton/CoreButton';
import LoadingButton from '../../Common/LoadingButton';
import {
  DeleteReviewResponse,
  FlagReviewResponse,
} from '../../../models/post-req-responses-payloads';
import { AppActionPostRequestResponseHandler, SubmitReviewRequestHandler } from '../AppActions/types';
import { isFeatureFlagEnabled} from '../../../utils/helpers';

type ReviewProps = {
  isFetching: boolean;
  minReviewListLimit?: number;
  reviews: EntityState<DeveloperAppReview>;
  readMore: () => void;
  readLess: () => void;
  reviewsListConfig: ReviewsConfig;
  totalReviewCount: number;
  reviewRemovedHandler: AppActionPostRequestResponseHandler<DeleteReviewResponse>;
  reportReviewHandler: AppActionPostRequestResponseHandler<FlagReviewResponse>,
  reviewSubmittedCallBack: SubmitReviewRequestHandler;
};

export const ReviewsList: React.FC<ReviewProps> = ({ reviews, readLess, readMore, reviewsListConfig, reviewRemovedHandler, reportReviewHandler, reviewSubmittedCallBack, totalReviewCount, minReviewListLimit =2, isFetching}) => {
  const [t] = useTranslation();
  const {data: developerResponseFeature} = useFetchServerFeaturesQuery({
    features: [ServerFeatures.DeveloperRatingsAndReviews]
  });
  const {showAll, limit} = reviewsListConfig;

  const ReadMoreOrLess: React.FC = (): Nullable<JSX.Element> => {
    if (totalReviewCount <= minReviewListLimit) return null;
    return (
      <div className={styles.button} data-testid='readMoreOrLess'>
        {
          showAll && !isFetching ? (
            <TertiaryButton onClick={readLess}>
              {t('buttons.read_less')}
            </TertiaryButton>
          ) : (
            <LoadingButton isLoading={isFetching} variant={ButtonVariant.TERTIARY}
                           text={t('app_details.read_all_reviews')} onClick={readMore} />
          )
        }
      </div>
    );
  };

  const developerResponseEnabled = isFeatureFlagEnabled(developerResponseFeature);

  return (
    <div>
      {reviews && reviews.ids.slice(0, showAll ? limit : minReviewListLimit).map((reviewId: EntityId) => {
          if (!reviewId) return;
          const review = reviews.entities[reviewId]!;
          return <CommentBlock
            key={reviewId}
            reviewData={review}
            developerResponseEnabled={developerResponseEnabled}
            reviewRemovedHandler={reviewRemovedHandler}
            reportReviewHandler={reportReviewHandler}
            reviewSubmittedCallBack={reviewSubmittedCallBack}
          />
        })}
      <ReadMoreOrLess/>
    </div>
  );
};
